import { FC } from 'react';
import { IconButton } from '../iconButton';
import closeIcon from 'assets/icons/close-icon.svg';
import closeWhiteIcon from 'assets/icons/close-icon-white.svg';

interface CloseIconButtonProps {
	onClick: () => void;
	styles?: {
		iconHeight: string;
		width?: string;
		height?: string;
	};
	hide?: boolean;
	light?: boolean;
	id?: string;
}

export const CloseIconButton: FC<CloseIconButtonProps> = ({
	onClick,
	styles = { iconHeight: '16px' },
	hide = false,
	light = false,
	id
}) => {
	return (
		<IconButton
			role="close-button"
			iconSrc={light ? closeWhiteIcon : closeIcon}
			styles={styles}
			onClick={onClick}
			disableTouch
			hide={hide}
			id={id}
		/>
	);
};
